const isNumericString = (value) => (
  typeof value === 'string' && /^-?\d+(\.\d+)?$/.test(value.trim())
);

const normalizeNumberToMs = (value) => {
  if (!Number.isFinite(value)) return null;
  const abs = Math.abs(value);
  if (abs >= 1e12) {
    return Math.floor(value);
  }
  return Math.floor(value * 1000);
};

export const toEpochMs = (value) => {
  if (value === null || value === undefined) return null;

  if (value instanceof Date) {
    const ms = value.getTime();
    return Number.isFinite(ms) ? ms : null;
  }

  if (typeof value === 'number') {
    return normalizeNumberToMs(value);
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;
    if (isNumericString(trimmed)) {
      return normalizeNumberToMs(Number(trimmed));
    }
    const parsed = Date.parse(trimmed);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

export const formatDateTime = (value, fallback = '--') => {
  const ms = toEpochMs(value);
  if (!Number.isFinite(ms)) return fallback;
  return new Date(ms).toLocaleString();
};
